<template>
  <div class="resend">
    <div class="resend__terms" v-html="$t('authentication-app.otp.terms')"></div>

    <div v-if="!isResendTimeout" class="resend__label">
      <i18n path="authentication-app.otp.resend">
        <template v-slot:time>
          <span class="resend__timer">{{ resendTimeString }}</span>
        </template>
      </i18n>
    </div>

    <div
      v-else
      class="resend__refresh"
      :class="{ disabled: isLoadingResend }"
    >
      <a
        v-show="isResendTimeout"
        :class="{ 'is-loading': isLoadingResend }"
        class="btn-link"
        href="#"
        @click.prevent="$emit('resend-otp')"
      >
        {{ $t('authentication-app.buttons.resend-otp') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resend',

  props: {
    isResendTimeout: {
      type: Boolean,
      required: true,
    },
    isLoadingResend: {
      type: Boolean,
      required: true,
    },
    resendTimeString: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

.resend {
  font-family: $font-regular;
  font-weight: normal;
  color: #dcdcdc;
  text-align: center;

  &__timer {
    display: inline-block;
    width: 37px;
  }

  &__refresh.disabled {
    pointer-events: none;
  }

  &__terms {
    display: none;
  }
}
</style>
